import HighlightWords from 'react-highlight-words';
import styled from 'styled-components';

export const StyledHighlightWords = styled(HighlightWords)`
  flex: 1;
  overflow: ${props => props.overflow ?? 'hidden'};
  text-overflow: ellipsis;
  pointer-events: none;
  min-width: ${props => props.minWidth ?? 'none'};

  .highlight {
    color: ${({ theme }) => theme.brand.color.light};
    background: none;
  }
`;
